import React from 'react'
import { Link } from 'react-router-dom';
const CbSection_1 = () => {
    return (
        <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                            Custom Built AI Agents
                        </h2>
                    </div>
                    <div className="text-wrapper mt-0">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            Leverage on our expertise to build your own AI Agents!
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link to="#how-do-we-do-it" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5">
                            <span data-text="How we do it?">How we do it?</span>
                        </Link>
                        <Link to="#gold-standard" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Gold standard">Gold standard</span>
                        </Link>
                        <Link to="#nlu-language-models" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="NLU/Language Models">
                                NLU/Language Models
                            </span>
                        </Link>
                        <Link to="#quick-to-Market" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Quick to market">Quick to market</span>
                        </Link>
                        <Link to="#co-create" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4">
                            <span data-text="Co-create">Co-create</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {CbSection_1}